import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded } from '../../../../layout/redux/layoutActions'

export const BLACKLIST_FETCH_REQUEST = 'BLACKLIST_FETCH_REQUEST'
export const BLACKLIST_FETCH_SUCCESS = 'BLACKLIST_FETCH_SUCCESS'
export const BLACKLIST_FETCH_FAILURE = 'BLACKLIST_FETCH_FAILURE'

export const BLACKLIST_REMOVE_REQUEST = 'BLACKLIST_REMOVE_REQUEST'
export const BLACKLIST_REMOVE_SUCCESS = 'BLACKLIST_REMOVE_SUCCESS'
export const BLACKLIST_REMOVE_FAILURE = 'BLACKLIST_REMOVE_FAILURE'

export const BLACKLIST_SELECT_ITEM = 'BLACKLIST_SELECT_ITEM'
export const BLACKLIST_CLEAR = 'BLACKLIST_CLEAR'

const normalizarTexto = valor => {
  if (valor === null || valor === undefined) return ''
  return String(valor).trim()
}

const normalizarAcoes = acoes => {
  if (!Array.isArray(acoes)) return []

  return acoes.map(item => ({
    id: item.id,
    titulo: normalizarTexto(item.titulo),
    descricao: normalizarTexto(item.descricao),
    setor: normalizarTexto(item.setor)
  }))
}

export const fetchBlacklist = projetoId => {
  return async dispatch => {
    dispatch({ type: BLACKLIST_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.get('/pdca/leracoesblacklist', {
        params: { projetoid: projetoId }
      })

      const data = response?.data || {}
      const acoes = normalizarAcoes(data?.acoes)
      const selecionada = acoes.length ? acoes[0] : null

      dispatch({
        type: BLACKLIST_FETCH_SUCCESS,
        payload: {
          acoes,
          selecionada
        }
      })
    } catch (error) {
      dispatch({
        type: BLACKLIST_FETCH_FAILURE,
        payload: error?.response?.data?.complemento || error?.message || 'Erro ao carregar blacklist.'
      })
    } finally {
      dispatch(loaded())
    }
  }
}

export const removeBlacklistAction = ({ projetoId, acaoId }) => {
  return async dispatch => {
    dispatch({ type: BLACKLIST_REMOVE_REQUEST, payload: acaoId })
    dispatch(loading())

    try {
      await apiPdca.post('/pdca/removeracoesblacklist', {
        projetoid: Number(projetoId),
        acoes: [Number(acaoId)]
      })

      dispatch({
        type: BLACKLIST_REMOVE_SUCCESS,
        payload: {
          acaoId: Number(acaoId)
        }
      })
    } catch (error) {
      dispatch({
        type: BLACKLIST_REMOVE_FAILURE,
        payload: error?.response?.data?.complemento || error?.message || 'Erro ao remover ação da blacklist.'
      })
    } finally {
      dispatch(loaded())
    }
  }
}

export const selectBlacklistItem = item => ({
  type: BLACKLIST_SELECT_ITEM,
  payload: item
})

export const clearBlacklist = () => ({
  type: BLACKLIST_CLEAR
})